import { parseJson } from 'lib/utils/helpers'

const ACCESS_TOKEN = 'access_token'
const SEO_DATA = 'seo_data'
const SEO_TOKEN = 'seo_token'
const SEO_DEPARTMENTS = 'seo_departments'
const SELECTION_ID = 'selection_id'
const CURRENT_STEP = 'current_step'
const USER_LOGIN = 'user_login'

export class LocalStorageService {
  static setAccessToken = accessToken =>
    localStorage.setItem(ACCESS_TOKEN, accessToken)

  static getAccessToken = () => localStorage.getItem(ACCESS_TOKEN)

  static removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN)

  static setDataFromSeo = data =>
    localStorage.setItem(SEO_DATA, JSON.stringify(data))
  static getDataFromSeo = () => parseJson(localStorage.getItem(SEO_DATA))
  static removeDataFromSeo = () => localStorage.removeItem(SEO_DATA)

  static setActiveSelectionId = id => localStorage.setItem(SELECTION_ID, id)
  static getSelectionId = () => localStorage.getItem(SELECTION_ID)
  static removeSelectionId = () => localStorage.removeItem(SELECTION_ID)

  static setCurrentStep = step => localStorage.setItem(CURRENT_STEP, step)
  static getCurrentStep = () => localStorage.getItem(CURRENT_STEP)
  static removeCurrentStep = () => localStorage.removeItem(CURRENT_STEP)

  static setLastLogin = login => localStorage.setItem(USER_LOGIN, login)
  static getLastLogin = () => localStorage.getItem(USER_LOGIN)
  static removeLastLogin = () => localStorage.removeItem(USER_LOGIN)

  static setSeoToken = token => localStorage.setItem(SEO_TOKEN, token)
  static getSeoToken = () => localStorage.getItem(SEO_TOKEN)
  static removeSeoToken = () => localStorage.removeItem(SEO_TOKEN)

  static setSeoDepartments = departments =>
    localStorage.setItem(SEO_DEPARTMENTS, JSON.stringify(departments))
  static getSeoDepartments = () =>
    parseJson(localStorage.getItem(SEO_DEPARTMENTS))
  static removeSeoDepartments = () => localStorage.removeItem(SEO_DEPARTMENTS)
}
